// 강의 뷰어 모듈 exports
import LectureViewer from './LectureViewer';
export { LectureViewer };
export default LectureViewer;
export { useLectureChat } from './hooks';
// 스타일 컴포넌트들은 필요 시에만 export
export * from './base-styles';
export * from './button-styles';
